import { render, staticRenderFns } from "./estadisticas-viajante-articulos.vue?vue&type=template&id=3d0cfea2&scoped=true&"
import script from "./estadisticas-viajante-articulos.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-viajante-articulos.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-viajante-articulos.vue?vue&type=style&index=0&id=3d0cfea2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0cfea2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VList,VListItem,VProgressCircular,VRow,VSpacer})
